export default __webpack_public_path__ + "static/nvcg-cf00d5d45461e685a526cbb9b04c193f.png";